export class ProfilesDto {
    id:string;
    name:string;
    emails:string;
    active:string;
}
